/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type DriveOnDriverInputInputType = typeof DriveOnDriverInputInputType[keyof typeof DriveOnDriverInputInputType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DriveOnDriverInputInputType = {
  UNDEFINED: 'UNDEFINED',
  TARGET_ASSIGNED: 'TARGET_ASSIGNED',
  TARGET_UNASSIGNED: 'TARGET_UNASSIGNED',
  LOGBOOK_CHANGED: 'LOGBOOK_CHANGED',
  MIDNIGHT_CLEANUP: 'MIDNIGHT_CLEANUP',
  KICKED: 'KICKED',
} as const;
